 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1101REPUDIATIONOFTHEHEAVENLYDAOASAPROOF from '@/components/0_chapter1101repudiationoftheheavenlydaoasaproof'
 import A_CHAPTER1102MANGFUINVOLVEDINSMALLINCIDENTS from '@/components/1_chapter1102mangfuinvolvedinsmallincidents'
 import A_CHAPTER1103TOBEAGUESTINPEACE from '@/components/2_chapter1103tobeaguestinpeace'
 import A_CHAPTER1104TRAINANDHIREGUARDS from '@/components/3_chapter1104trainandhireguards'
 import A_CHAPTER1105WANGMUSTHREEEAGLES from '@/components/4_chapter1105wangmusthreeeagles'
 import A_CHAPTER1106ZUZUBORDERTOWN from '@/components/5_chapter1106zuzubordertown'
 import A_CHAPTER1107EXTRASENSORYAVATAROFHAND from '@/components/6_chapter1107extrasensoryavatarofhand'
 import A_CHAPTER1108SOLVEONESDOUBTSWITHAWINDFALL from '@/components/7_chapter1108solveonesdoubtswithawindfall'
 import A_CHAPTER1109THIEVESSECTCHAMBEROFCOMMERCE from '@/components/8_chapter1109thievessectchamberofcommerce'
 import A_CHAPTER1110THEDANGEROFWORMHOLEINBEEPREFECTURE from '@/components/9_chapter1110thedangerofwormholeinbeeprefecture'
 import A0_CHAPTER1111THEFANTASYOFTHEMIXEDFIGHTINGHIBISCUS from '@/components/10_chapter1111thefantasyofthemixedfightinghibiscus'
 import A1_CHAPTER1112DECEITFULREQUESTTOBEPUTINTHEPOT from '@/components/11_chapter1112deceitfulrequesttobeputinthepot'
 import A2_CHAPTER1113SPLITTHEHIVEANDLEAVETHENEST from '@/components/12_chapter1113splitthehiveandleavethenest'
 import A3_CHAPTER1114CONSPIRACYJOINTMILITARYACTION from '@/components/13_chapter1114conspiracyjointmilitaryaction'
 import A4_CHAPTER1115ADUELTURNEDHOSTILE from '@/components/14_chapter1115aduelturnedhostile'
 import A5_CHAPTER1116SWORDSKILLSHOCKINGFOURSEALS from '@/components/15_chapter1116swordskillshockingfourseals'
 import A6_CHAPTER1117THANKYOUFORTHREATENINGTHESECT from '@/components/16_chapter1117thankyouforthreateningthesect'
 import A7_CHAPTER1118MISLEDSURVEILLANCECRISIS from '@/components/17_chapter1118misledsurveillancecrisis'
 import A8_CHAPTER1119HOMINIDREAPPEARANCE from '@/components/18_chapter1119hominidreappearance'
 import A9_CHAPTER1120THEINITIALAPPEARANCEOFTHESLAUGHTERINGCITYGOLDENDRAGON from '@/components/19_chapter1120theinitialappearanceoftheslaughteringcitygoldendragon'
 import A0_CHAPTER1121THECITYWASBUILTTOSHELTERTHELIPEOPLE from '@/components/20_chapter1121thecitywasbuilttoshelterthelipeople'
 import A1_CHAPTER1122TRAPSFRIGHTENOFFPROTOZOON from '@/components/21_chapter1122trapsfrightenoffprotozoon'
 import A2_CHAPTER1123OPPORTUNITYTRIPTOPWC from '@/components/22_chapter1123opportunitytriptopwc'
 import A3_CHAPTER1124REPRIMANDINGSHANGLUUNIMPEDED from '@/components/23_chapter1124reprimandingshangluunimpeded'
 import A4_CHAPTER1125AVISITTOTHESOUTHCHINASEA from '@/components/24_chapter1125avisittothesouthchinasea'
 import A5_CHAPTER1126ITISHARDTOFINDFAULTWITHBUDDHA from '@/components/25_chapter1126itishardtofindfaultwithbuddha'
 import A6_CHAPTER1127XUANYEXUANWUBLOCKINGROAD from '@/components/26_chapter1127xuanyexuanwublockingroad'
 import A7_CHAPTER1128REDEEMERSSTATEMENT from '@/components/27_chapter1128redeemersstatement'
 import A8_CHAPTER1129SOBBINGFORTWOSLIPPERS from '@/components/28_chapter1129sobbingfortwoslippers'
 import A9_CHAPTER1130CONGREGATIONSOFPOISONEDENEMIES from '@/components/29_chapter1130congregationsofpoisonedenemies'
 import A0_CHAPTER1131BORINGBUSINESSOPPORTUNITY from '@/components/30_chapter1131boringbusinessopportunity'
 import A1_CHAPTER1132MARKETINGOFFLIGHTEQUIPMENT from '@/components/31_chapter1132marketingofflightequipment'
 import A2_CHAPTER1133THESTALLSWEREBLOCKEDBYPEOPLE from '@/components/32_chapter1133thestallswereblockedbypeople'
 import A3_CHAPTER1134HUMANNATUREFIREPLAYBLACKMARTIALARTS from '@/components/33_chapter1134humannaturefireplayblackmartialarts'
 import A4_CHAPTER1135MISUNDERSTANDINGBATTLEUPGRADE from '@/components/34_chapter1135misunderstandingbattleupgrade'
 import A5_CHAPTER1136EXPLANATIONOFTHEANGRYXUANWU from '@/components/35_chapter1136explanationoftheangryxuanwu'
 import A6_CHAPTER1137PROTOZOA from '@/components/36_chapter1137protozoa'
 import A7_CHAPTER1138SNAKEMONSTERRAINBOWDACE from '@/components/37_chapter1138snakemonsterrainbowdace'
 import A8_CHAPTER1139FORGINGAFAKETOSAVETHELIFEOFTHEGODLYFISH from '@/components/38_chapter1139forgingafaketosavethelifeofthegodlyfish'
 import A9_CHAPTER1140HINTATTHEHEARTOFTHECITYLORD from '@/components/39_chapter1140hintattheheartofthecitylord'
 import A0_CHAPTER1141SELLINGFISHINTHENORTHSEA from '@/components/40_chapter1141sellingfishinthenorthsea'
 import A1_CHAPTER1142THECALAMITYOFTHEINTERNALFIGHTINGDIVINEFISH from '@/components/41_chapter1142thecalamityoftheinternalfightingdivinefish'
 import A2_CHAPTER1143INSECLUSIONTHEOLDTURTLEASKFORADEBT from '@/components/42_chapter1143inseclusiontheoldturtleaskforadebt'
 import A3_CHAPTER1144DEVOURSECLUSIONCLOUD from '@/components/43_chapter1144devourseclusioncloud'
 import A4_CHAPTER1145CRISISLOSSOFSIXSENSES from '@/components/44_chapter1145crisislossofsixsenses'
 import A5_CHAPTER1146BIDDINGOFFMONSTERSATAHIGHERPRICE from '@/components/45_chapter1146biddingoffmonstersatahigherprice'
 import A6_CHAPTER1147OPPORTUNITYNORTHSEACRISIS from '@/components/46_chapter1147opportunitynorthseacrisis'
 import A7_CHAPTER1148ASTRONGATTACKONTHEMAINCITY from '@/components/47_chapter1148astrongattackonthemaincity'
 import A8_CHAPTER1149RESTORATIONOFFREEDOMBYTURBULENCE from '@/components/48_chapter1149restorationoffreedombyturbulence'
 import A9_CHAPTER1150VARIABLECHAOSLAW from '@/components/49_chapter1150variablechaoslaw'
 import A0_CHAPTER1151GREATCHANGEOLDTURTLEISWILLING from '@/components/50_chapter1151greatchangeoldturtleiswilling'
 import A1_CHAPTER1152CONDEMNEDGARRISONBORDER from '@/components/51_chapter1152condemnedgarrisonborder'
 import A2_CHAPTER1153ACRYFORHELPISACRYFORMERCY from '@/components/52_chapter1153acryforhelpisacryformercy'
 import A3_CHAPTER1154THEBEGINNINGOFTHEWORLD from '@/components/53_chapter1154thebeginningoftheworld'
 import A4_CHAPTER1155FEASTINTHEPAST from '@/components/54_chapter1155feastinthepast'
 import A5_CHAPTER1156THEFOURGODSOFTRUTH from '@/components/55_chapter1156thefourgodsoftruth'
 import A6_CHAPTER1157TRUEBODYREINCARNATIONOFPANGU from '@/components/56_chapter1157truebodyreincarnationofpangu'
 import A7_CHAPTER1158TOGAINORLOSEISTOGAINORLOSEONESFREEDOM from '@/components/57_chapter1158togainorloseistogainorloseonesfreedom'
 import A8_CHAPTER1159NEGOTIATINGTHEAURACRISIS from '@/components/58_chapter1159negotiatingtheauracrisis'
 import A9_CHAPTER1160OPPORTUNITYTORAISEADEMON from '@/components/59_chapter1160opportunitytoraiseademon'
 import A0_CHAPTER1161MYSTERYTEASESKAOLIN from '@/components/60_chapter1161mysteryteaseskaolin'
 import A1_CHAPTER1162THEMYSTERYOFTHEGREATVOIDDAOFATHER from '@/components/61_chapter1162themysteryofthegreatvoiddaofather'
 import A2_CHAPTER1163THEBEGINNINGOFTHEDISSOLUTIONOFTHECHAOS from '@/components/62_chapter1163thebeginningofthedissolutionofthechaos'
 import A3_CHAPTER1164THEENCHANTMENTOFPREPARINGFORWAR from '@/components/63_chapter1164theenchantmentofpreparingforwar'
 import A4_CHAPTER1165THECAUSEOFTHEBLACKTURTLE from '@/components/64_chapter1165thecauseoftheblackturtle'
 import A5_CHAPTER1166EXITINGFROMSECLUSIONTOCELEBRATEWITHTHEHEAVENS from '@/components/65_chapter1166exitingfromseclusiontocelebratewiththeheavens'
 import A6_CHAPTER1167GUESSWHOSTHEEVIL from '@/components/66_chapter1167guesswhostheevil'
 import A7_CHAPTER1168FINALTRIALOFREINCARNATION from '@/components/67_chapter1168finaltrialofreincarnation'
 import A8_CHAPTER1169SCRATCHTHINGUANYIN from '@/components/68_chapter1169scratchthinguanyin'
 import A9_CHAPTER1170HEARTMECHANISM from '@/components/69_chapter1170heartmechanism'
 import A0_CHAPTER1171SUBSEQUENTPREVIOUSLIFECRISIS from '@/components/70_chapter1171subsequentpreviouslifecrisis'
 import A1_CHAPTER1172ABETTINGONTHESTRUGGLEFORTAOISM from '@/components/71_chapter1172abettingonthestrugglefortaoism'
 import A2_CHAPTER1173ARROGANCEATTHEENDOFTHEDAY from '@/components/72_chapter1173arroganceattheendoftheday'
 import A3_CHAPTER1174HOSTAGEBLACKTURTLEDISPATCH from '@/components/73_chapter1174hostageblackturtledispatch'
 import A4_CHAPTER1175BEATTHEMERCYOFOTHERS from '@/components/74_chapter1175beatthemercyofothers'
 import A5_CHAPTER1176LIFESTYLE from '@/components/75_chapter1176lifestyle'
 import A6_CHAPTER1177JOINTSITANDSHARETHELOOT from '@/components/76_chapter1177jointsitandsharetheloot'
 import A7_CHAPTER1178SURGEUNDERCURRENT from '@/components/77_chapter1178surgeundercurrent'
 import A8_CHAPTER1179MERCENARYTHUNDERSPIRITHANDLER from '@/components/78_chapter1179mercenarythunderspirithandler'
 import A9_CHAPTER1180THEBATTLEOFTENTHOUSANDBLESSINGS from '@/components/79_chapter1180thebattleoftenthousandblessings'
 import A0_CHAPTER1181PINGDINGDINGFEN from '@/components/80_chapter1181pingdingdingfen'
 import A1_CHAPTER1182AGREETORETURNTOBEEPREFECTURE from '@/components/81_chapter1182agreetoreturntobeeprefecture'
 import A2_CHAPTER1183THREATENEDSWORDFINGEROFBUDDHISM from '@/components/82_chapter1183threatenedswordfingerofbuddhism'
 import A3_CHAPTER1184THELOWERREALMSOFTHECOMMANDERSOFTHEDEMONS from '@/components/83_chapter1184thelowerrealmsofthecommandersofthedemons'
 import A4_CHAPTER1185ONTHESWORDSOFTENBILLIONPEOPLE from '@/components/84_chapter1185ontheswordsoftenbillionpeople'
 import A5_CHAPTER1186DISGUISEDTIGERBODYTECHNIQUE from '@/components/85_chapter1186disguisedtigerbodytechnique'
 import A6_CHAPTER1187ITISDIFFICULTTODISMOUNTFROMTHISBATTLEOFSOULS from '@/components/86_chapter1187itisdifficulttodismountfromthisbattleofsouls'
 import A7_CHAPTER1188EXORCISMISASEASYASFLIPPINGONESHAND from '@/components/87_chapter1188exorcismisaseasyasflippingoneshand'
 import A8_CHAPTER1189POSSESSIONDOORTODOORCEREMONY from '@/components/88_chapter1189possessiondoortodoorceremony'
 import A9_CHAPTER1190TALKINGABOUTTHEHEARTOFTIGRESS from '@/components/89_chapter1190talkingabouttheheartoftigress'
 import A0_CHAPTER1191ADEBTTODEFYTHEWILLOFTHEHEAVENS from '@/components/90_chapter1191adebttodefythewilloftheheavens'
 import A1_CHAPTER1192AMISUNDERSTANDINGISAMISCALCULATION from '@/components/91_chapter1192amisunderstandingisamiscalculation'
 import A2_CHAPTER1193SHOULINGCOMPETITION from '@/components/92_chapter1193shoulingcompetition'
 import A3_CHAPTER1194THEPOWEROFTHESWANKYHEAVENLYDAO from '@/components/93_chapter1194thepoweroftheswankyheavenlydao'
 import A4_CHAPTER1195HEWAVEDHISHANDANDWALKEDAWAY from '@/components/94_chapter1195hewavedhishandandwalkedaway'
 import A5_CHAPTER1196COMPULSORYEXCUSEFORREVEALINGTHESTUFFING from '@/components/95_chapter1196compulsoryexcuseforrevealingthestuffing'
 import A6_CHAPTER1197EXORCISMEXORCISM from '@/components/96_chapter1197exorcismexorcism'
 import A7_CHAPTER1198AWORLDEXTERMINATINGWAROFGRUDGES from '@/components/97_chapter1198aworldexterminatingwarofgrudges'
 import A8_CHAPTER1199LEAFOFTHEVOID from '@/components/98_chapter1199leafofthevoid'
 import A9_CHAPTER1200GREATVOIDSHOCKING from '@/components/99_chapter1200greatvoidshocking'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1101repudiationoftheheavenlydaoasaproof",
 			"name" : "0_chapter1101repudiationoftheheavenlydaoasaproof",
 			"component" : A_CHAPTER1101REPUDIATIONOFTHEHEAVENLYDAOASAPROOF
 		},
 		{
 			"path" : "/1_chapter1102mangfuinvolvedinsmallincidents",
 			"name" : "1_chapter1102mangfuinvolvedinsmallincidents",
 			"component" : A_CHAPTER1102MANGFUINVOLVEDINSMALLINCIDENTS
 		},
 		{
 			"path" : "/2_chapter1103tobeaguestinpeace",
 			"name" : "2_chapter1103tobeaguestinpeace",
 			"component" : A_CHAPTER1103TOBEAGUESTINPEACE
 		},
 		{
 			"path" : "/3_chapter1104trainandhireguards",
 			"name" : "3_chapter1104trainandhireguards",
 			"component" : A_CHAPTER1104TRAINANDHIREGUARDS
 		},
 		{
 			"path" : "/4_chapter1105wangmusthreeeagles",
 			"name" : "4_chapter1105wangmusthreeeagles",
 			"component" : A_CHAPTER1105WANGMUSTHREEEAGLES
 		},
 		{
 			"path" : "/5_chapter1106zuzubordertown",
 			"name" : "5_chapter1106zuzubordertown",
 			"component" : A_CHAPTER1106ZUZUBORDERTOWN
 		},
 		{
 			"path" : "/6_chapter1107extrasensoryavatarofhand",
 			"name" : "6_chapter1107extrasensoryavatarofhand",
 			"component" : A_CHAPTER1107EXTRASENSORYAVATAROFHAND
 		},
 		{
 			"path" : "/7_chapter1108solveonesdoubtswithawindfall",
 			"name" : "7_chapter1108solveonesdoubtswithawindfall",
 			"component" : A_CHAPTER1108SOLVEONESDOUBTSWITHAWINDFALL
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js